import React, { useState, useEffect } from 'react';
import TileBoard from '../components/TileBoard';

const getGridSizeFromDifficulty = (difficulty) => {
  switch (difficulty) {
    case 'easy': return 3;
    case 'medium': return 4;
    case 'hard': return 5;
    default: return 5;
  }
};

const PuzzleGameScreen = ({ selectedPuzzle, difficulty, setCurrentScreen, setGameTime, setIsGameWon, setErrorMessage }) => {
  const [startTime, setStartTime] = useState(null);
  const [gridSize, setGridSize] = useState(getGridSizeFromDifficulty(difficulty));

  useEffect(() => {
    if (!selectedPuzzle || !difficulty) {
      setErrorMessage('Missing puzzle or difficulty. Please try again.');
      setCurrentScreen('selectPuzzle');
      return;
    }
    setStartTime(Date.now());
    setGridSize(getGridSizeFromDifficulty(difficulty));
  }, [difficulty, selectedPuzzle, setCurrentScreen, setErrorMessage]);

  const handleWin = () => {
    const finishTime = Date.now();
    const timeTaken = Math.floor((finishTime - startTime) / 1000);
    setGameTime(timeTaken);
    setIsGameWon(true);
    setCurrentScreen('result');
  };

  const handleQuit = () => {
    setIsGameWon(false);
    setCurrentScreen('result');
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-4">
      <h2 className="text-2xl font-bold text-pink-600 mb-4">Solve the Puzzle!</h2>
      <p className="mb-4 text-gray-700">Difficulty: <span className="capitalize font-bold">{difficulty}</span> ({gridSize}×{gridSize})</p>
      <TileBoard
        image={selectedPuzzle?.imageUrl}
        gridSize={gridSize}
        onWin={handleWin}
      />
      <button
        onClick={handleQuit}
        className="mt-6 bg-red-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-red-600 transition"
      >
        Quit
      </button>
    </div>
  );
};

export default PuzzleGameScreen;
